import { render, staticRenderFns } from "./ProcessoArtefatoInteracao.vue?vue&type=template&id=66525d92&scoped=true"
import script from "./ProcessoArtefatoInteracao.vue?vue&type=script&lang=js"
export * from "./ProcessoArtefatoInteracao.vue?vue&type=script&lang=js"
import style0 from "./ProcessoArtefatoInteracao.vue?vue&type=style&index=0&id=66525d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66525d92",
  null
  
)

export default component.exports